import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
const loadScripts = script => {
  const s = document.createElement('script');
  s.src = script;
  document.head.appendChild(s);
};

if (environment.production) {
  enableProdMode();
  loadScripts('assets/js/pixels/facebook.js');
}
loadScripts('assets/app/js/dashboard-custom.js');

// Add strip key based on config. reason to keep in main it to load the script before anyother bundles loads.
// If we keep in index.html, environment variable is not there
document.write(
  '<script type="text/javascript">var stripe = Stripe("' +
    environment.STRIPE_KEY +
    '");var elements = stripe.elements();</script>'
);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));



// WEBPACK FOOTER //
// ./src/main.ts